import { getAEMUrl } from "@jti/fe-common";
const redirectToAuthPage = (config) => {
    if (!window || !config) {
        return;
    }
    const { AUTH_PAGE_URL, "base-url": baseUrl } = config;
    const returnUrl = encodeURIComponent(baseUrl);
    const redirectUrl = `${getAEMUrl("#/login", AUTH_PAGE_URL)}?returnUrl=${returnUrl}`;
    window.location.href = redirectUrl;
};
export default redirectToAuthPage;
//# sourceMappingURL=redirectToAuthPage.js.map